import { LogoutOutlined, UserOutlined } from "@ant-design/icons"
import { Avatar, Space, Typography, Dropdown } from "antd"
import { Link as RouterLink } from "react-router-dom"
import { useAuthContext } from "../../../hooks/useAuthContext"
import { useLogout } from "../../../hooks/useLogout"

const { Text } = Typography

export function UserTop(props) {
  //imports logout functionality hook
  const { logout } = useLogout()
  //gets user
  const { user } = useAuthContext()

  // items for menu
  const items = [
    {
      key: "profile",
      label: <RouterLink to="/user-profile">My Profile</RouterLink>,
    },
    {
      key: "updates",
      label: <RouterLink to="/latest-updates">Latest Updates</RouterLink>,
    },
    {
      key: "signout",
      label: (
        <RouterLink onClick={logout}>
          Logout <LogoutOutlined />
        </RouterLink>
      ),
    },
  ]

  return (
    <div style={{ marginRight: 20 }}>
      <Space size="middle">
        <Space align="center">
          <Text style={{ color: "white" }}>{props.user && props.user.email}</Text>
          <Dropdown menu={{ items }} placement="bottomRight" arrow>
            <Avatar
              size={35}
              src={user.photoURL ? user.photoURL : ""}
              icon={user.photoURL ? "" : <UserOutlined />}
            />
          </Dropdown>
        </Space>
      </Space>
    </div>
  )
}
